import {clientAlderaan} from '../../core/stores';
import {QUERY_ALDERAAN_USERS} from '../../core/graphql/types';

export interface UserOption {
  id: string;
  name?: string;
  lastName?: string;
  email: string;
}

export function QueryUsers(search: string, first = 20): Promise<UserOption[]> {
  return clientAlderaan
    .query({
      query: QUERY_ALDERAAN_USERS,
      variables: {search, first},
      fetchPolicy: 'network-only',
    })
    .then(({data}) => data?.users || [])
    .catch(() => []);
}
